import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const CheckoutEditorLazy = loadable(() => import(/* webpackChunkName: "CheckoutEditor" */ './CheckoutEditorSuspense'));

export const CheckoutEditorAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <CheckoutEditorLazy />
    </DelayedSuspense>
);
